// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"047599f0","453":"36666f68"}[chunkId] + ".chunk.js";
};